import React from "react";
import "./Header.css";
import { Link } from "react-router-dom";
import { getUser, logout } from "../webapi/AuthService";

import Person from "@mui/icons-material/Person";
import HeaderUploadIcon from "./upload/HeaderUploadIcon";

const Header = () => {
  const handleLogOut = async () => {
    logout();
  };

  return (
    <div className="header">
      <div className="headerSearch"></div>
      <div className="headerMenu">
        <div className="headerMenuItem">
          <HeaderUploadIcon />
        </div>
        <div className="headerMenuItem" onClick={handleLogOut}>
          <Link to="/signin">
            <span className="headerMenuUser d-none d-lg-block">
              <Person />
              {getUser()}
            </span>
          </Link>
        </div>
      </div>
    </div>
  );
};
export default Header;
